import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import logo from "../assets/ojoto_union_logo.png";
import { 
  FaBars, FaTimes, FaUserCircle,
  FaChevronDown
} from "react-icons/fa";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [aboutDropdown, setAboutDropdown] = useState(false);
  const [programsDropdown, setProgramsDropdown] = useState(false);
  const [getInvolvedDropdown, setGetInvolvedDropdown] = useState(false);
  const [resourcesDropdown, setResourcesDropdown] = useState(false);
  const [profileDropdown, setProfileDropdown] = useState(false);
  
  const { user, logout, isAuthenticated } = useAuth();
  const location = useLocation();

  const toggleMenu = () => setIsOpen(!isOpen);
  
  const closeAll = () => {
    setIsOpen(false);
    setAboutDropdown(false);
    setProgramsDropdown(false);
    setGetInvolvedDropdown(false);
    setResourcesDropdown(false);
    setProfileDropdown(false);
  };

  const handleLogout = () => {
    logout();
    closeAll();
  };

  const hideDropdown = (label) => {
    setTimeout(() => {
      if (label === "About") setAboutDropdown(false);
      if (label === "Programs") setProgramsDropdown(false);
      if (label === "Get Involved") setGetInvolvedDropdown(false);
      if (label === "Resources") setResourcesDropdown(false);
    }, 120);
  };

  const navLinks = isAuthenticated 
    ? [
        { to: "/dashboard", label: "Dashboard" },
      ]
    : [
        { to: "/", label: "Home" },
        { 
          label: "About", 
          hasDropdown: true,
          dropdownItems: [
            { to: "/about", label: "Overview" },
            { to: "/about/story", label: "Our Story" },
            { to: "/about/approach", label: "Our Approach" },
            { to: "/about/team", label: "Our Team" },
            { to: "/about/supporters", label: "Our Supporters" },
            { to: "/about/partners", label: "Our Partners" }
          ]
        },
        { 
          label: "Programs",
          hasDropdown: true,
          dropdownItems: [
            { to: "/programs/employability-skills", label: "Employability Skills" },
            { to: "/programs/mentorship", label: "Mentorship Program" }
          ]
        },
        { 
          label: "Get Involved",
          hasDropdown: true,
          dropdownItems: [
            { to: "/get-involved/donor", label: "Be A Donor" },
            { to: "/get-involved/corporate-donor", label: "Be A Corporate Donor" }
          ]
        },
        { 
          label: "Resources",
          hasDropdown: true,
          dropdownItems: [
            { to: "/resources/news-events", label: "News & Events" },
            { to: "/resources/newsletters", label: "Newsletters" },
            { to: "/resources/careers", label: "Careers" }
          ]
        },
        { to: "/success-stories", label: "Success Stories" },
        { to: "/contact", label: "Contact" }
      ];

  const isActive = (path) => location.pathname === path;
  const isActiveParent = (items) => items?.some(item => isActive(item.to));

  return (
    <>
      <nav 
        className="bg-white sticky top-0 z-50 shadow-md"
        style={{ 
          height: '80px',
          borderBottom: '1px solid #E5E7EB'
        }}
      >
        <div className="max-w-7xl mx-auto px-6 h-full">
          <div className="flex items-center justify-between h-full">
            {/* Logo + Organization Name */}
            <Link 
              to={isAuthenticated ? "/dashboard" : "/"} 
              onClick={closeAll}
              className="flex items-center gap-3 flex-shrink-0"
            >
          <img
            src={logo}
            alt="Ojoto Union Logo"
                className="h-12 w-12 object-cover"
          />
          <div className="flex flex-col">
                <span 
                  className="text-lg font-semibold leading-tight"
                  style={{ 
                    fontFamily: "'Open Sans', system-ui, sans-serif",
                    fontWeight: 600,
                    color: '#1E40AF'
                  }}
                >
                  OJOTO UNION
            </span>
                <span 
                  className="text-xs leading-tight"
                  style={{ 
                    fontFamily: "'Open Sans', system-ui, sans-serif",
                    color: '#6B7280'
                  }}
                >
                  North America
            </span>
          </div>
        </Link>

            {/* Desktop Menu */}
            <div className="hidden md:flex items-center h-full">
              <div className="flex items-center gap-6">
                {navLinks.map((link, index) => {
                  if (link.hasDropdown) {
                    const dropdownState = 
                      link.label === "About" ? aboutDropdown :
                      link.label === "Programs" ? programsDropdown :
                      link.label === "Get Involved" ? getInvolvedDropdown :
                      resourcesDropdown;
                    
                    const setDropdownState = 
                      link.label === "About" ? setAboutDropdown :
                      link.label === "Programs" ? setProgramsDropdown :
                      link.label === "Get Involved" ? setGetInvolvedDropdown :
                      setResourcesDropdown;

                    const isParentActive = isActiveParent(link.dropdownItems);

                    return (
                      <div
                        key={index}
                        className="relative h-full flex items-center"
                        onMouseEnter={() => {
                          setDropdownState(true);
                        }}
                        onMouseLeave={() => hideDropdown(link.label)}
                      >
                        <button
                          onClick={() => setDropdownState(!dropdownState)}
                          className={`flex items-center gap-1.5 h-full transition-colors ${
                            dropdownState || isParentActive
                              ? 'text-[#F59E0B]' 
                              : 'text-[#1E40AF] hover:text-[#F59E0B]'
                          }`}
                          style={{
                            fontFamily: "'Open Sans', system-ui, sans-serif",
                            fontWeight: 600,
                            fontSize: '15px',
                            padding: '0 12px'
                          }}
                        >
                          {link.label}
                          <FaChevronDown className={`text-xs transition-transform ${dropdownState ? 'rotate-180' : ''}`} />
                        </button>
                        {dropdownState && (
                          <div 
                            className="absolute top-full left-0 bg-white rounded-lg shadow-xl border border-gray-200 overflow-hidden min-w-[220px] py-2 z-50"
                            style={{
                              boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)'
                            }}
                            onMouseEnter={() => {
                              setDropdownState(true);
                            }}
                            onMouseLeave={() => hideDropdown(link.label)}
                          >
                            {link.dropdownItems.map((item, idx) => (
                  <Link
                                key={idx}
                    to={item.to}
                    onClick={closeAll}
                                className={`block px-5 py-2.5 text-sm transition-all duration-200 ${
                                  isActive(item.to) 
                                    ? 'bg-[#F59E0B] bg-opacity-10 text-[#F59E0B] font-semibold border-l-4 border-[#F59E0B]' 
                                    : 'text-gray-700 hover:bg-gray-50 hover:text-[#F59E0B] hover:pl-6'
                                }`}
                                style={{
                                  fontFamily: "'Open Sans', system-ui, sans-serif"
                                }}
                  >
                    {item.label}
                  </Link>
                            ))}
                      </div>
                        )}
                      </div>
                    );
                  }

                  return (
                    <Link
                      key={index}
                      to={link.to}
                      onClick={closeAll}
                      className={`transition-colors ${
                        isActive(link.to) 
                          ? 'text-[#F59E0B]' 
                          : 'text-[#1E40AF] hover:text-[#F59E0B]'
                      }`}
                      style={{
                        fontFamily: "'Open Sans', system-ui, sans-serif",
                        fontWeight: 600,
                        fontSize: '15px',
                        padding: '0 12px'
                      }}
                    >
                      {link.label}
                    </Link>
                  );
                })}
              </div>

              {/* Login Link / Profile - Right Aligned */}
              <div className="ml-6 pl-6 border-l border-gray-200">
                {isAuthenticated ? (
                  <div className="relative">
                    <button
                      onClick={() => setProfileDropdown(!profileDropdown)}
                      className="flex items-center gap-2 text-[#1E40AF] hover:text-[#F59E0B] transition-colors"
                      style={{
                        fontFamily: "'Open Sans', system-ui, sans-serif",
                        fontWeight: 600,
                        fontSize: '15px'
                      }}
                    >
                      <FaUserCircle size={20} />
                      <span>{user?.firstName || "User"}</span>
                      <FaChevronDown className={`text-xs transition-transform ${profileDropdown ? 'rotate-180' : ''}`} />
                    </button>
                    {profileDropdown && (
                      <div 
                        className="absolute right-0 mt-2 bg-white rounded-lg shadow-xl border border-gray-200 overflow-hidden min-w-[200px] py-2 z-50"
                        style={{
                          boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)'
                        }}
                        onMouseLeave={() => setProfileDropdown(false)}
                      >
                    <Link
                          to="/settings"
                      onClick={closeAll}
                          className={`block px-5 py-2.5 text-sm transition-all duration-200 ${
                            isActive('/settings')
                              ? 'bg-[#F59E0B] bg-opacity-10 text-[#F59E0B] font-semibold border-l-4 border-[#F59E0B]' 
                              : 'text-gray-700 hover:bg-gray-50 hover:text-[#F59E0B] hover:pl-6'
                          }`}
                          style={{
                            fontFamily: "'Open Sans', system-ui, sans-serif"
                          }}
                        >
                          Settings
                    </Link>
                    <button
                      onClick={handleLogout}
                          className="block w-full text-left px-5 py-2.5 text-sm text-gray-700 hover:bg-gray-50 hover:text-[#F59E0B] transition-all duration-200 hover:pl-6"
                          style={{
                            fontFamily: "'Open Sans', system-ui, sans-serif"
                          }}
                        >
                          Logout
                    </button>
                      </div>
                    )}
                  </div>
                ) : (
                  <Link
                    to="/login"
                    onClick={closeAll}
                    className="text-[#1E40AF] hover:text-[#F59E0B] transition-colors"
                    style={{
                      fontFamily: "'Open Sans', system-ui, sans-serif",
                      fontWeight: 600,
                      fontSize: '15px'
                    }}
                  >
                    Login
                  </Link>
                )}
              </div>
            </div>

            {/* Mobile Hamburger */}
                <button
              className="md:hidden text-[#1E40AF]"
              onClick={toggleMenu}
            >
              {isOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
                </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden border-t border-gray-200 bg-white">
            <div className="max-w-7xl mx-auto px-6 py-4 space-y-4">
              {navLinks.map((link, index) => {
                if (link.hasDropdown) {
                  return (
                    <div key={index}>
                      <div 
                        className="text-gray-900 font-semibold mb-2"
                        style={{
                          fontFamily: "'Open Sans', system-ui, sans-serif",
                          fontWeight: 600,
                          color: '#1E40AF'
                        }}
                      >
                        {link.label}
                      </div>
                      <div className="pl-4 space-y-2">
                        {link.dropdownItems.map((item, idx) => (
                          <Link
                            key={idx}
                            to={item.to}
                            className={`block text-sm transition-colors ${
                              isActive(item.to) 
                                ? 'text-[#F59E0B] font-semibold' 
                                : 'text-gray-600 hover:text-[#F59E0B]'
                            }`}
                            onClick={closeAll}
                            style={{
                              fontFamily: "'Open Sans', system-ui, sans-serif"
                            }}
                          >
                            {item.label}
                          </Link>
                        ))}
                      </div>
                    </div>
                  );
                }
                return (
                  <Link
                    key={index}
                    to={link.to}
                    className={`block text-sm font-semibold transition-colors ${
                      isActive(link.to) 
                        ? 'text-[#F59E0B]' 
                        : 'text-[#1E40AF] hover:text-[#F59E0B]'
                    }`}
                    onClick={closeAll}
                    style={{
                      fontFamily: "'Open Sans', system-ui, sans-serif",
                      fontWeight: 600
                    }}
                  >
                    {link.label}
                  </Link>
                );
              })}
              {isAuthenticated ? (
                <>
                  <div className="border-t border-gray-200 mt-4 pt-4">
                    <div className="flex items-center gap-2 text-gray-900 mb-2">
                      <FaUserCircle size={18} className="text-[#1E40AF]" />
                      <span 
                        className="font-semibold"
                        style={{
                          fontFamily: "'Open Sans', system-ui, sans-serif",
                          fontWeight: 600,
                          color: '#1E40AF'
                        }}
                      >
                        {user?.firstName || "User"}
                      </span>
                    </div>
                    <Link
                      to="/settings"
                      className="block text-sm text-gray-600 hover:text-[#F59E0B] transition-colors mt-2 pl-6"
                      onClick={closeAll}
                      style={{
                        fontFamily: "'Open Sans', system-ui, sans-serif"
                      }}
                    >
                      Settings
                    </Link>
                    <button
                      onClick={handleLogout}
                      className="block w-full text-left text-sm text-gray-600 hover:text-[#F59E0B] transition-colors mt-2 pl-6"
                      style={{
                        fontFamily: "'Open Sans', system-ui, sans-serif"
                      }}
                    >
                      Logout
                    </button>
                  </div>
                </>
              ) : (
                    <Link
                      to="/login"
                  className="block text-sm font-semibold text-[#1E40AF] hover:text-[#F59E0B] transition-colors mt-4"
                      onClick={closeAll}
                  style={{
                    fontFamily: "'Open Sans', system-ui, sans-serif",
                    fontWeight: 600
                  }}
                    >
                  Login
                    </Link>
          )}
            </div>
      </div>
        )}
      </nav>

      {/* Close dropdowns when clicking outside */}
      {(aboutDropdown || programsDropdown || getInvolvedDropdown || resourcesDropdown || profileDropdown) && (
        <div
          className="fixed inset-0 z-40"
          onClick={closeAll}
        />
      )}
    </>
  );
};

export default Navbar;
